
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { Grid, Tooltip } from '@mui/material'
import { retrieveCertification } from '../../../../ts/Common';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

const styles = {
    dropDownSettingsBox: {
        backgroundColor: '#FFFFFF',
        textArea: {
            color: '#4B4E65'
        },
        mt: 1
    }
}

export default function DropDownSetting(props: any) {
    const { element, display_name, machine, navigateToMatchmaking, disabledState } = props;
    const navigate = useNavigate();
    const { t } = useTranslation();

    var selectOptions = element['Option'].map((item: any, i: any) => {
        if (item === "") {
            return <MenuItem key={i} value=""><em>{t('control.settings.none')}</em></MenuItem>
        }
        return <MenuItem key={i} value={item}>{item}</MenuItem>
    })

    const dropDown = <FormControl fullWidth>
        <TextField
            select
            defaultValue={element['value']}
            disabled={disabledState}
            size="small"
            InputProps={{
                startAdornment: (
                    <InputAdornment sx={styles.dropDownSettingsBox.textArea} position="start">{display_name} :</InputAdornment>
                )
            }}
            onChange={(e: any) => {
                if (display_name === "Certification") {
                    element.Set(e.target.value)
                        .then((data: any) => {
                            retrieveCertification(machine)
                                .then((data: any) => {
                                    if (data['Responses']['GetCertification']['code'] === '0') {
                                        machine.certification = data['Responses']['GetCertification']
                                    }
                                })
                                .catch(() => {
                                    navigateToMatchmaking();
                                })
                        })
                } else if (display_name === "Mode") {
                    element.Set(e.target.value)
                        .then(() => {
                            alert("Spectre Core is restarting, please re-connect to your machine through Matchmaking")
                            navigate("/matchmaking");
                        })
                        .catch(() => {
                            navigateToMatchmaking();
                        })
                } else {
                    element.Set(e.target.value)
                        .catch(() => {
                            navigateToMatchmaking();
                        })
                }
            }}
        >
            {selectOptions}
        </TextField>
    </FormControl>

    return (
        <Grid item xs={12} lg={6} sx={styles.dropDownSettingsBox}>
            {element.Tooltip && element.Tooltip !== "no name" ?
                <Tooltip title={element.Tooltip} placement="top">
                    {dropDown}
                </Tooltip>
                :
                dropDown
            }
        </Grid>
    )

}